<template>
  <section class="u-containar" v-if="news.length > 0">
    <HeadingLv2 text="新着ニュース" icon="megaphone" />

    <div class="homeNews">
      <NewsList :isHome="true" :news="news" />
    </div>

    <Button
      :handleClick="onButtonClicked"
      href="/news"
      label="ニュース一覧へ"
      primary
    />
  </section>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import HeadingLv2 from '@/components/elements/HeadingLv2.vue'
import Button from '@/components/elements/Button.vue'
import NewsList from '@/components/block/NewsList.vue'

export default defineComponent({
  name: 'HomeNews',

  components: {
    NewsList,
    HeadingLv2,
    Button
  },

  setup() {
    const store = useStore()
    const router = useRouter()
    const onButtonClicked = () => {
      router.push('/news')
    }
    return {
      news: computed(() => store.getters['home/getNews']),
      onButtonClicked
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.homeNews {
  margin-bottom: 10px;

  @include mixins.media() {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 25px;
  }
}
</style>
